module.exports = __webpack_public_path__ + "img/loud-speaker.08cbfe85.svg";